export const home = {
  // Hero Section
  hero_title: 'Empowering Your Digital Future',
  hero_subtitle: 'Leading IT solutions and generative AI services for modern businesses',
  hero_cta_primary: 'Explore Our Solutions',
  hero_cta_secondary: 'Contact Us',
  
  // Services Section
  services_title: 'Our Services',
  services_subtitle: 'Comprehensive IT solutions tailored to your business needs',
  
  service_hardware_title: 'Hardware Solutions',
  service_hardware_desc: 'Enterprise-grade servers, workstations, and network infrastructure',
  
  service_software_title: 'Software Services',
  service_software_desc: 'Business software, security solutions, and cloud services',
  
  service_it_title: 'IT Consulting',
  service_it_desc: 'Strategic IT consulting and digital transformation services',
  
  service_ai_title: 'Generative AI',
  service_ai_desc: 'Advanced AI solutions and machine learning services',
  
  // Solutions Section
  solutions_title: 'IT Solutions',
  solutions_subtitle: 'End-to-end solutions for your business needs',
  
  solution_cloud_title: 'Cloud Services',
  solution_cloud_desc: 'Scalable cloud infrastructure and migration services',
  
  solution_security_title: 'Cyber Security',
  solution_security_desc: 'Comprehensive security solutions to protect your business',
  
  solution_infrastructure_title: 'Infrastructure',
  solution_infrastructure_desc: 'IT infrastructure optimization and management',
  
  solution_digital_title: 'Digital Transformation',
  solution_digital_desc: 'Modernize your business with digital technologies',
  
  // AI Section
  ai_title: 'Generative AI Solutions',
  ai_subtitle: 'Transform your business with cutting-edge AI technology',
  
  ai_consulting_title: 'AI Consulting',
  ai_consulting_desc: 'Strategic AI consulting and implementation planning',
  
  ai_automation_title: 'AI Automation',
  ai_automation_desc: 'Automate business processes with AI technology',
  
  ai_vision_title: 'Computer Vision',
  ai_vision_desc: 'Advanced image recognition and analysis solutions',
  
  ai_conversational_title: 'Conversational AI',
  ai_conversational_desc: 'Intelligent chatbots and virtual assistants',
  
  // Infrastructure Section
  infrastructure_title: 'Infrastructure Optimization',
  infrastructure_subtitle: 'Build a robust and scalable IT infrastructure',
  infrastructure_desc: 'Our infrastructure optimization services help you create a reliable, secure, and efficient IT environment that grows with your business.',
  
  infrastructure_feature1_title: 'Network Design',
  infrastructure_feature1_desc: 'Custom network architecture for optimal performance',
  
  infrastructure_feature2_title: 'Server Management',
  infrastructure_feature2_desc: '24/7 monitoring and maintenance of your servers',
  
  infrastructure_feature3_title: 'Cloud Integration',
  infrastructure_feature3_desc: 'Seamless integration with cloud platforms',
  
  infrastructure_feature4_title: 'Disaster Recovery',
  infrastructure_feature4_desc: 'Comprehensive backup and recovery solutions',
  
  // Digital Transformation Section
  transformation_title: 'Digital Transformation',
  transformation_subtitle: 'Modernize your business for the digital age',
  transformation_desc: 'We help organizations navigate their digital journey with strategic planning, technology implementation, and change management.',
  
  transformation_step1_title: 'Assessment',
  transformation_step1_desc: 'Evaluate your current digital maturity',
  
  transformation_step2_title: 'Strategy',
  transformation_step2_desc: 'Develop a comprehensive transformation roadmap',
  
  transformation_step3_title: 'Implementation',
  transformation_step3_desc: 'Execute solutions with minimal disruption',
  
  transformation_step4_title: 'Optimization',
  transformation_step4_desc: 'Continuously improve and scale',
  
  // Featured Products Section
  products_title: 'Featured Products',
  products_subtitle: 'Discover our most popular hardware and software solutions',
  
  // CTA Section
  cta_title: 'Ready to Transform Your IT Infrastructure?',
  cta_subtitle: 'Get in touch with our team of experts today',
  cta_button: 'Request a Quote',
  
  // Partner Form
  form_title: 'Request a Quote',
  form_subtitle: 'Fill out the form below and our team will get back to you within 24 hours',
  form_name: 'Full Name',
  form_email: 'Email Address',
  form_phone: 'Phone Number',
  form_company: 'Company Name',
  form_service: 'Service of Interest',
  form_service_placeholder: 'Select a service',
  form_message: 'Message',
  form_message_placeholder: 'Tell us about your project...',
  form_submit: 'Request Quote',
  form_submitting: 'Submitting...',
  form_success: 'Thank you! We will get back to you soon.',
  form_error: 'Something went wrong. Please try again.',
  
  // Service Options
  service_option_hardware: 'Hardware Solutions',
  service_option_software: 'Software Services',
  service_option_it_services: 'IT Services',
  service_option_cloud: 'Cloud Services',
  service_option_security: 'Cyber Security',
  service_option_ai: 'Generative AI',
  service_option_consulting: 'IT Consulting',
  service_option_other: 'Other',
};

export default home;
